import { takeLatest, put, call, select } from 'redux-saga/effects';
import moment from 'moment';

import { LOADER_OPEN, LOADER_CLOSE } from '../actions';
import {
  ACADEMY_LIST_GET,
  ACADEMY_DETAILS_GET,
  ACADEMY_SET_FAVOURITE,
  ACADEMY_LO_SET_LIKEDISLIKE,
  ACADEMY_COURSE_DETAILS_SET_VIEWS,
  ACADEMY_LO_SET_VIEWS,
  ACADEMY_LO_SET_COMMENT,
  ACADEMY_CATEGORIES_GET,
} from '../actions/academy';

import academy from '../../api/academy';
import { getDefaultLanguage } from '../../../utils/locale';
import { truncateWithDots } from '../../../utils/common';
import { DRUPAL_MAX_TITLE_LENGTH } from '../../../const';

// ============== LIST ==============
function* academyListGet({ loader = true, subset = false, area, progress }) {
  try {
    if (loader) yield put({ type: LOADER_OPEN });

    const { pager: { current_page = 0, total_pages = 1 } = {} } =
      yield select(state => state.academy || {});

    const next_page  = subset ? (Number(current_page) + 1) : 1;
    const isLastPage = subset && Number(current_page) >= Number(total_pages);
    if (isLastPage) return;

    const { defaultLanguage } = getDefaultLanguage();
    const filters = {
      items_per_page: 24,
      page: next_page,
      area,
      progress,
      lang: defaultLanguage,
      type: 'academy'
    };

    const { data: { data, pager } = {} } = yield call(academy.getAcademyList, filters);
    yield put({ type: ACADEMY_LIST_GET._SUCCESS, data, pager, subset });
  } catch (err) {
    yield put({ type: ACADEMY_LIST_GET._ERROR });
  } finally {
    if (loader) yield put({ type: LOADER_CLOSE });
  }
}

function* academyListGetWatch() {
  yield takeLatest(ACADEMY_LIST_GET._REQUEST, academyListGet);
}

// ============== DETAILS ==============
function* academyDetailsGet({ id }) {
  if (!id) return;
  try {
    yield put({ type: LOADER_OPEN });
    const { defaultLanguage } = getDefaultLanguage();
    const params = { id, lang: defaultLanguage, type: 'academy'};
    const { data: { data = {} } = {} } = yield call(academy.getAcademyDetails, params);
    yield put({ type: ACADEMY_DETAILS_GET._SUCCESS, data });
  } catch (err) {
    yield put({ type: ACADEMY_DETAILS_GET._ERROR });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}
function* academyDetailsGetWatch() {
  yield takeLatest(ACADEMY_DETAILS_GET._REQUEST, academyDetailsGet);
}

// ============== FAVOURITE (course) ==============
function* favouriteSet({ nid }) {
  if (!nid) return;
  try {
    const payload = { nid, node_type: 'academy', action_type: 'favourite' };
    yield call(academy.setNodeAction, payload);
    yield put({ type: ACADEMY_SET_FAVOURITE._SUCCESS });
  } catch (err) {}
}
function* favouriteSetWatch() {
  yield takeLatest(ACADEMY_SET_FAVOURITE._REQUEST, favouriteSet);
}

// ============== LIKE/DISLIKE (LO) ==============
function* loSetLikeDislike({ nid, action_type }) {
  if (!nid || !action_type) return;
  try {
    const payload = { nid, action_type, node_type: 'learning_object' };
    yield call(academy.setNodeAction, payload);
    yield put({ type: ACADEMY_LO_SET_LIKEDISLIKE._SUCCESS, nid, action_type });
  } catch (err) {}
}
function* loSetLikeDislikeWatch() {
  yield takeLatest(ACADEMY_LO_SET_LIKEDISLIKE._REQUEST, loSetLikeDislike);
}

// ============== VIEWS (course) ==============
function* academyCourseDetailsSetViews({ nid }) {
  if (!nid) return;
  try {
    const payload = { nid, action_type: 'views', node_type: 'academy' };
    yield call(academy.setNodeAction, payload);
    yield put({ type: ACADEMY_COURSE_DETAILS_SET_VIEWS._SUCCESS, nid });
  } catch (err) {}
}
function* academyCourseDetailsSetViewsWatch() {
  yield takeLatest(ACADEMY_COURSE_DETAILS_SET_VIEWS._REQUEST, academyCourseDetailsSetViews);
}

// ============== VIEWS (LO) ==============
function* loSetViews({ nid }) {
  if (!nid) return;
  try {
    const payload = { nid, action_type: 'views', node_type: 'learning_object' };
    yield call(academy.setNodeAction, payload);
    yield put({ type: ACADEMY_LO_SET_VIEWS._SUCCESS, lo_id: nid });
  } catch (err) {}
}
function* loSetViewsWatch() {
  yield takeLatest(ACADEMY_LO_SET_VIEWS._REQUEST, loSetViews);
}

// ============== COMMENT (LO) ==============
function* loSetComment({ body }) {
  try {
    const payload = {
      entity_id: [{ target_id: body.id }],
      entity_type: [{ value: 'node' }],
      comment_type: [{ target_id: 'comment' }],
      field_name: [{ value: 'comment' }],
      subject: [{ value: truncateWithDots(body.subject, DRUPAL_MAX_TITLE_LENGTH) }],
      comment_body: [{ value: body.comment_body }],
    };
    yield call(academy.setComment, payload);

    const { data: { first_name, last_name } = {} } = yield select(state => state.user || {});
    yield put({
      type: ACADEMY_LO_SET_COMMENT._SUCCESS,
      lo_id: body.id,
      payload: {
        first_name,
        last_name,
        comment_body: body.comment_body,
        created: moment().unix(),
        changed: moment().unix(),
      },
    });
  } catch (err) {}
}
function* loSetCommentWatch() {
  yield takeLatest(ACADEMY_LO_SET_COMMENT._REQUEST, loSetComment);
}

// ============== CATEGORIES (una tantum) ==============
function* categoriesGet() {
  try {
    const { defaultLanguage } = getDefaultLanguage();
    const params = { lang: defaultLanguage, type: 'academy' };
    const { data: { categories = [] } = {} } = yield call(academy.getCategories, params);
    yield put({ type: ACADEMY_CATEGORIES_GET._SUCCESS, categories });
  } catch (err) {}
}
function* categoriesGetWatch() {
  yield takeLatest(ACADEMY_CATEGORIES_GET._REQUEST, categoriesGet);
}

export default [
  academyListGetWatch(),
  academyDetailsGetWatch(),
  favouriteSetWatch(),
  loSetLikeDislikeWatch(),
  academyCourseDetailsSetViewsWatch(),
  loSetViewsWatch(),
  loSetCommentWatch(),
  categoriesGetWatch(),
];
